import { css } from '@emotion/react';

import { ComponentType, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const _SKELETON_LIST = [...new Array(10).keys()];

const skeletonListCSS = css`
  overflow: hidden;
  max-height: 100vh;
`;

type Props = {
  skeleton: ComponentType;
};

const SkeletonList = ({ skeleton: Skeleton }: Props) => {
  const { inView, ref, entry } = useInView();
  const [skeletonHeight, setSkeletonHeight] = useState<number>();

  useEffect(() => {
    if (inView && entry) {
      setSkeletonHeight(window.innerHeight - entry.boundingClientRect.top);
    }
  }, [inView]);

  return (
    <div
      css={skeletonListCSS}
      ref={ref}
      style={skeletonHeight ? { height: skeletonHeight } : undefined}
    >
      {_SKELETON_LIST.map((i) => (
        <Skeleton key={`skeleton-${i}`} />
      ))}
    </div>
  );
};

export default SkeletonList;
